/*
 * Copyright (c) 2021. CodeGen Ltd. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Chiranthana Thennakoon on 31/08/2021.
 */
import dpCriteriaOperations from './dp-criteria-operations.json';

const PermissionKeys = {
  DP_TOUR_FETCH_ENABLE: 'SURF_DP_TOUR_FETCH_ENABLE'
};

const exportDpCriteriaOperations = () => {
  return dpCriteriaOperations;
};

export { PermissionKeys, exportDpCriteriaOperations };
